import {httpGet,httpPut,httpDelete,httpPost,httpPostForm,httpDownload} from '@/util/request.js';
import appConfig from '@/config';

export default class ShopPointApi {
    static baseUrl = appConfig.gatewayUrl + appConfig.pdServicePath;
// static baseUrl = "http://localhost:20065/pd-service" ;

    static LIST_ALL_SUBJECT = ShopPointApi.baseUrl + "/wb/pd-xj-shop-point/subject"
    static LIST_ALL_POINT = ShopPointApi.baseUrl + "/wb/pd-xj-shop-point/point"
    static LIST_SHOP_POINT = ShopPointApi.baseUrl + "/wb/pd-xj-shop-point/list"
    static SHOP_POINT_IMPORT_TEMPLATE = ShopPointApi.baseUrl + "/wb/pd-xj-shop-point/importTemplate"
    static SHOP_POINT_IMPORT_DATA = ShopPointApi.baseUrl + "/wb/pd-xj-shop-point/importData"
	static SHOP_POINT_TYPE_IMPORT_TEMPLATE = ShopPointApi.baseUrl + "/wb/pd-xj-shop-point/importPointTypeTemplate"
	static SHOP_POINT_TYPE_IMPORT_DATA = ShopPointApi.baseUrl + "/wb/pd-xj-shop-point/importPointTypeData"
    static SHOP_POINT_EXPORT_DATA = ShopPointApi.baseUrl + "/wb/pd-xj-shop-point/exportData"
    static DISABLE_SHOP_POINT = ShopPointApi.baseUrl + "/wb/pd-xj-shop-point/disable"
    static ENABLE_SHOP_POINT = ShopPointApi.baseUrl + "/wb/pd-xj-shop-point/enable"
    static LIST_POINT_ITEM = ShopPointApi.baseUrl + "/wb/pd-xj-shop-point/item"
    static BATCH_EXPORT_QRCODE = ShopPointApi.baseUrl + "/wb/pd-xj-shop-point/qrcode/batch"
    static EXPORT_QRCODE = ShopPointApi.baseUrl + "/wb/pd-xj-shop-point/qrcode";
    static UPDATE_SHOP_POINT = ShopPointApi.baseUrl + "/wb/pd-xj-shop-point/save"
	
	 //    static LIST_SHOP_POINT = "http://localhost:20065/pd-service" + "/wb/pd-xj-shop-point/list"
		// static SHOP_POINT_EXPORT_DATA = "http://localhost:20065/pd-service" + "/wb/pd-xj-shop-point/exportData"
		// static SHOP_POINT_IMPORT_TEMPLATE = "http://localhost:20065/pd-service" + "/wb/pd-xj-shop-point/importTemplate"
		// static SHOP_POINT_IMPORT_DATA = "http://localhost:20065/pd-service" + "/wb/pd-xj-shop-point/importData"

    static allSubject(){
        return httpGet(ShopPointApi.LIST_ALL_SUBJECT, {});
    }

    static allPoint(){
        return httpGet(ShopPointApi.LIST_ALL_POINT, {});
    }

    static list(param){
        return httpGet(ShopPointApi.LIST_SHOP_POINT, param);
    }

    static importTemplate(params){
        return httpDownload(ShopPointApi.SHOP_POINT_IMPORT_TEMPLATE,params);
    }

    static importData(file) {
        let formData = new FormData()
        formData.append('file', file);
        return httpPost(ShopPointApi.SHOP_POINT_IMPORT_DATA, formData);
    }
	
	static importPointTypeTemplate(params){
	    return httpDownload(ShopPointApi.SHOP_POINT_TYPE_IMPORT_TEMPLATE,params);
	}
	
	static importPointTypeData(file) {
	    let formData = new FormData()
	    formData.append('file', file);
	    return httpPost(ShopPointApi.SHOP_POINT_TYPE_IMPORT_DATA, formData);
	}

    static exportData(param) {
        return httpDownload(ShopPointApi.SHOP_POINT_EXPORT_DATA, param);
    }

    static save(param){
        return httpPut(ShopPointApi.UPDATE_SHOP_POINT, param);
    }

    static disable(param) {
        return httpPut(ShopPointApi.DISABLE_SHOP_POINT, param);
    }

    static enable(param) {
        return httpPut(ShopPointApi.ENABLE_SHOP_POINT, param);
    }

    static item(param){
        return httpGet(ShopPointApi.LIST_POINT_ITEM, param);
    }

    static batchExportQrcode(param){
        return httpDownload(ShopPointApi.BATCH_EXPORT_QRCODE, param);
    }

    static exportQrcode(param){
        return httpDownload(ShopPointApi.EXPORT_QRCODE, param);
    }

}